<template>
    <NavbarComp class="absolute inset-x-0 top-0 z-50" @sendData="receiveData" :value="comp_click"/>
    <div class="relative">
        <div class="relative min-h-screen min-w-screen bg-fixed bg-cover bg-center brightness-75" style="background-image: url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxleHBsb3JlLWZlZWR8MXx8fGVufDB8fHx8fA%3D%3D');"></div>
        
        <!-- <div class="video-background relative min-h-screen min-w-screen bg-fixed bg-cover bg-center brightness-75">
            <video autoplay muted loop>
                <source src="../assets/video-bg.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div> -->
        
        <div class="absolute inset-0 flex flex-col items-center justify-center text-center">
            <h1 class="text-white text-xl mb-2 sm:text-md fade-content" v-if="!buttonClicked">Welcome to AirProve</h1>
            <h2 class="text-white text-2xl mb-2 sm:text-md fade-content" v-else>Search flights</h2>
            <h2 class="text-white text-4xl font-bold tracking-widest sm:text-lg lg:text-2xl fade-content" v-if="!buttonClicked">
                YOUR JOURNEY STARTS HERE
            </h2>
            <!-- <p class="text-white text-4xl font-bold tracking-widest sm:text-lg lg:text-2xl fade-content" v-if="!buttonClicked">YOUR JOURNEY STARTS HERE</p> -->
            <br>
            <transition name="fade">
                <div v-if="comp_click" class="fade-content">
                    <FlightSearch/>
                </div>
                <div v-else class="fade-content">
                    <TailwindButton @click="change_form" v-if="!buttonClicked"/>
                </div>
            </transition>
        </div>
        <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2">
            <a href="#specials" aria-label="Read more about AirProve Travel Agency">
                <svg class="animate-bounce w-8 h-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
                </svg>
            </a>
        </div>
    </div>
    <div class="">
        <section id="specials">
            <div class="flex items-center justify-center">
                <p class="text-3xl font-bold tracking-tight m-10 text-blue-500">Travel Tips</p>
            </div>
            <div class="flex items-center justify-center">
                <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-10 gap-5 mb-10">
                    <div class="relative w-80 h-80 sm:w-48 sm:h-48 lg:w-80 lg:h-80 flex items-center justify-center bg-fixed bg-right-top group overflow-hidden" style="background-image: url('https://e1.pxfuel.com/desktop-wallpaper/743/27/desktop-wallpaper-love-of-my-life-travel-aesthetic.jpg');">
                        <div class="absolute bg-black opacity-80 inset-0 transition-opacity duration-300 group-hover:opacity-25"></div>
                        <div class="text-white text-center z-10">
                            <h4 class="text-xl font-bold text-widest mb-4 sm:text-sm lg:text-xl">OUTWARD BOUND</h4>
                            <button name="learnMore" @click="outwardBoundPage" class="bg-blue-500 text-white px-4 py-2 rounded-full" id="learn-more">Learn More</button>
                        </div>
                    </div>
                    <div class="relative w-80 h-80 sm:w-48 sm:h-48 lg:w-80 lg:h-80 flex items-center justify-center bg-fixed bg-center bg-no-repeat group overflow-hidden" style="background-image: url('https://www.letsroam.com/explorer/wp-content/uploads/sites/10/2022/01/cultural-travel.jpg'); background-size: cover;">
                        <div class="absolute bg-black opacity-80 inset-0 absolute bg-black opacity-75 inset-0 transition-opacity duration-300 group-hover:opacity-25"></div>
                        <div class="text-white text-center z-10">
                            <h4 class="text-xl font-bold text-widest mb-4 sm:text-sm lg:text-xl">CULTURE-CURIOUS</h4>
                            <button name="learnMore" @click="cultureCurious" class="bg-blue-500 text-white px-4 py-2 rounded-full" id="learn-more">Learn More</button>
                        </div>
                    </div>

                    <div class="relative w-80 h-80 sm:w-48 sm:h-48 lg:w-80 lg:h-80 flex items-center justify-center bg-fixed bg-right-bottom group overflow-hidden" style="background-image: url('https://hips.hearstapps.com/hmg-prod/images/large-group-of-happy-friends-in-mountains-area-royalty-free-image-1653422631.jpg?crop=0.668xw:1.00xh;0.0609xw,0&resize=1200:*');">
                        <div class="absolute bg-black opacity-80 inset-0 transition-opacity duration-300 group-hover:opacity-25"></div>
                        <div class="text-white text-center z-10">
                            <h4 class="text-xl font-bold text-widest mb-4 sm:text-sm lg:text-xl">RELAX, RELATE, RELEASE</h4>
                            <button name="learnMore" @click="relaxPage" class="bg-blue-500 text-white px-4 py-2 rounded-full" id="learn-more">Learn More</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

    <section id="brandnew">
        <BrandnewComp/>
        <div id="ad_id">
            <amp-ad width="100vw" height="320"
                type="adsense"
                data-ad-client="ca-pub-5580517504444924"
                data-ad-slot="8950603964"
                data-auto-format="rspv"
                data-full-width="">
                <div overflow=""></div>
            </amp-ad>
        </div>
    </section>

    <section id="headlines">
        <BlogComp/>
        <div id="ad_id">
            <amp-ad width="100vw" height="320"
                type="adsense"
                data-ad-client="ca-pub-5580517504444924"
                data-ad-slot="8950603964"
                data-auto-format="rspv"
                data-full-width="">
                <div overflow=""></div>
            </amp-ad>
        </div>
    </section>
    <!-- Holiday Packages -->
        <!-- <div class="mb-10">
            <section id="feature">
                <div class="bg-yellow-400">
                    <div class="flex items-center justify-center">
                        <div class="grid md:grid-cols-2 gap-4 mx-4 mt-5 mb-5">
                            <div class="my-5 flex items-center justify-center">
                                <festivitiesSVG/>
                            </div>
                            <div class="">
                                <a href="#" class="flex flex-row items-center h-full">
                                    <div class="flex flex-col justify-between p-4 leading-normal w-full">
                                        <h5 class="mb-3 text-5xl font-bold tracking-tight text-white text-center">Holiday Packages</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center my-10">
                    <div v-if="length_of_holi === 0">
                        <div class="my-5">
                            <div class="">
                                <a class="flex flex-row items-center h-full">
                                    <div class="flex flex-col justify-between p-4 leading-normal w-full">
                                        <h5 class="mb-3 text-2xl font-bold tracking-tight text-blue-500 text-center">No flights available yet</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="page_loaded === false">
                            <div role="status" class="flex justify-center items-center my-5">
                                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-10 gap-4">
                                <div v-for="holi in holiday_flights.slice().reverse()" :key="holi">
                                    <div class="max-w-sm rounded shadow-lg">
                                        <div class="aspect-w-16 aspect-h-9">
                                            <img class="object-cover h-48 w-96" :src="holi.photo_link" alt="Sunset in the mountains">
                                        </div>
                                        <div class="px-6 py-4 bg-white overflow-hidden h-64">
                                            <div class="font-bold text-xl mb-2">{{ holi.destination }}</div>
                                            <p class="text-gray-700 text-base text-justify">
                                                {{ truncatedDescription(holi.description) }}
                                            </p>
                                        </div>
                                        <div class="px-6 pt-4 pb-2 flex items-center justify-center bg-white">
                                            <button @click="bookHoli(holi.id)" type="button" class="text-blue-700 w-80 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Book now!</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div> -->
    <!-- End -->
        
        <!-- Domestic -->
        <!-- <div class="mb-10">
            <section id="feature">
                <div class="bg-blue-500">
                    <div class="flex items-center justify-center">
                        <div class="grid md:grid-cols-2 gap-4 mx-4 mt-5 mb-5">
                            <div class="my-5 flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" class="w-80 h-80" viewBox="0 0 982.48732 763.01413" xmlns:xlink="http://www.w3.org/1999/xlink"><circle cx="559.4329" cy="333.06116" r="40.02979" fill="#e6e6e6"/><path d="M766.295,452.99465l-41.832-41.832a44.307,44.307,0,0,0-14.42627-61.92578,44.45758,44.45758,0,0,0-58.91358,12.23779,44.30652,44.30652,0,0,0,60.03321,62.99512l41.832,41.832A9.40939,9.40939,0,0,0,766.295,452.99465ZM709.59431,409.6011a31.68421,31.68421,0,1,1,9.27978-22.40381A31.58568,31.58568,0,0,1,709.59431,409.6011Z" transform="translate(-108.75634 -68.49293)" fill="#3f3d56"/><path d="M1069.529,514.69884C1176.50914,633.00725,866.39184,803.50707,615.8095,803.50707S191.86334,671.39983,162.09,514.69884C89.89987,134.75174,777.16735-106.74054,615.8095,225.89055,380.61181,710.73882,985.27984,421.5284,1069.529,514.69884Z" transform="translate(-108.75634 -68.49293)" fill="#e6e6e6"/><path d="M1021.529,542.69884C1128.50914,661.00725,818.39184,831.50707,567.8095,831.50707S143.86334,699.39983,114.09,542.69884C41.89987,162.75174,729.16735-78.74054,567.8095,253.89055,332.61181,738.73882,937.27984,449.5284,1021.529,542.69884Z" transform="translate(-108.75634 -68.49293)" fill="#3f3d56"/><path d="M258.35026,265.31823c-75.06741-3.30525-133.27133-19.49788-132.50668-36.86436.45844-10.41178,21.70324-18.7842,58.28677-22.96955a1,1,0,1,1,.22727,1.987c-34.46168,3.943-56.11733,12.01678-56.516,21.07051-.69148,15.70451,59.11433,31.63093,130.59659,34.77832s132.4564-7.461,133.14787-23.16554c.40032-9.09178-20.59681-19.06558-54.79775-26.0284a1.00008,1.00008,0,1,1,.3991-1.95993c36.3011,7.39058,56.85694,17.624,56.39672,28.0763C392.81953,257.60908,333.41767,268.62348,258.35026,265.31823Z" transform="translate(-108.75634 -68.49293)" fill="#6c63ff"/><path d="M191.67927,268.22672a76.98277,76.98277,0,0,0,133.03578,5.52178A1211.97551,1211.97551,0,0,1,191.67927,268.22672Z" transform="translate(-108.75634 -68.49293)" fill="#6c63ff"/><path d="M333.019,252.71347a76.997,76.997,0,1,0-147.74945-5.70562A572.23325,572.23325,0,0,0,333.019,252.71347Z" transform="translate(-108.75634 -68.49293)" fill="#6c63ff"/><circle cx="168.83353" cy="123.60073" r="9" fill="#fff"/><circle cx="122.51347" cy="152.59128" r="15" fill="#fff"/><circle cx="348.90479" cy="142.89813" r="9.99975" fill="#6c63ff"/><circle cx="122.90479" cy="452.89813" r="6.00007" fill="#e6e6e6"/><circle cx="542.90479" cy="658.89813" r="6.00007" fill="#e6e6e6"/><circle cx="151.90479" cy="339.89813" r="3.00007" fill="#e6e6e6"/><circle cx="399.90479" cy="563.89813" r="3.00007" fill="#e6e6e6"/><circle cx="850.90479" cy="534.89813" r="3.00007" fill="#e6e6e6"/><circle cx="709.90479" cy="623.89813" r="3.00007" fill="#e6e6e6"/><circle cx="562.90479" cy="515.89813" r="3.00007" fill="#e6e6e6"/><circle cx="372.90479" cy="219.89813" r="3.00007" fill="#e6e6e6"/><circle cx="396.90479" cy="71.89813" r="3.00007" fill="#e6e6e6"/><circle cx="382.90479" cy="694.89813" r="3.00007" fill="#e6e6e6"/><circle cx="234.90479" cy="631.89813" r="3.00007" fill="#e6e6e6"/><circle cx="703.90479" cy="523.89813" r="3.00007" fill="#e6e6e6"/><circle cx="148.3737" cy="224.7987" r="9" fill="#fff"/><path d="M460.6612,431.39114c0,26.88035-41.55939,89.516-53.70465,107.24669a3.99188,3.99188,0,0,1-6.5907,0c-12.14526-17.73066-53.70465-80.36634-53.70465-107.24669a57,57,0,1,1,114,0Z" transform="translate(-108.75634 -68.49293)" fill="#fff"/><circle cx="294.90486" cy="358.8982" r="29" fill="#6c63ff"/><ellipse cx="294.40486" cy="496.3982" rx="33.5" ry="6.5" fill="#fff"/><path d="M925.60957,386.41245a10.52681,10.52681,0,0,0-.64106,1.52851l-47.783,13.27682-8.61085-8.42662L854.1589,404.12429,867.953,420.52338a8,8,0,0,0,9.35283,2.169l51.61632-22.78484a10.49709,10.49709,0,1,0-3.31256-13.49509Z" transform="translate(-108.75634 -68.49293)" fill="#ffb8b8"/><path d="M875.50191,401.996l-17.9352,13.95958a4.5,4.5,0,0,1-6.68163-1.33719L839.73843,394.891a12.49741,12.49741,0,0,1,19.76923-15.29426l16.33819,15.59379a4.5,4.5,0,0,1-.34394,6.80543Z" transform="translate(-108.75634 -68.49293)" fill="#6c63ff"/><path d="M930.19158,379.80967l18.18807,8.1829a3.14913,3.14913,0,0,1,1.57976,4.16384l-2.15339,4.78633a1.05293,1.05293,0,0,1,.52659,1.38795l-.86136,1.91453a1.05292,1.05292,0,0,1-1.388.52659l-.86136,1.91453a1.05292,1.05292,0,0,1,.52659,1.388l-.86136,1.91453a1.0529,1.0529,0,0,1-1.38794.52659L931.8709,432.36162a3.14914,3.14914,0,0,1-4.16384,1.57977l-18.18807-8.1829a3.14915,3.14915,0,0,1-1.57977-4.16384l18.08852-40.20522A3.14913,3.14913,0,0,1,930.19158,379.80967Z" transform="translate(-108.75634 -68.49293)" fill="#3f3d56"/><path d="M912.82137,423.21181l14.59056,6.57106a3.03424,3.03424,0,0,0,3.99937-1.51155l6.73892-14.98951,2.34078-5.196,6.09875-13.562a3.026,3.026,0,0,0-1.51149-3.98886l-4.58726-2.06786L930.47694,383.964a3.02112,3.02112,0,0,0-3.98861,1.522L920.589,398.59669l-6.7179,14.92653-2.56118,5.69979A3.022,3.022,0,0,0,912.82137,423.21181Z" transform="translate(-108.75634 -68.49293)" fill="#f2f2f2"/><polygon points="773.577 540.443 785.837 540.442 791.67 493.154 773.575 493.155 773.577 540.443" fill="#ffb8b8"/><path d="M879.2066,604.93325l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38648,15.38623v.5l-39.53052.00146Z" transform="translate(-108.75634 -68.49293)" fill="#2f2e41"/><polygon points="805.577 537.443 817.837 537.442 823.67 490.154 805.575 490.155 805.577 537.443" fill="#ffb8b8"/><path d="M911.2066,601.93325l24.1438-.001h.001a15.38605,15.38605,0,0,1,15.38648,15.38623v.5l-39.53052.00146Z" transform="translate(-108.75634 -68.49293)" fill="#2f2e41"/><path d="M827.34138,497.97109a39.41035,39.41035,0,0,0,36.8999,26.81006l.62012.01c6.32959.18,13.75976-1.86,21.0498-4.79,14.3999-5.79,28.23-15.06,31.8999-17.61l-6.21972,59.79-2.52,24.24a4.51415,4.51415,0,0,0,4.48,4.97h15.52978a4.50547,4.50547,0,0,0,4.35987-3.36l25.64013-97.65a19.032,19.032,0,0,0-19.71-23.83l-53.25976,3.65,3.71972-14.88-47.54-3.16-.13965.1c-1.14013.83-2.25,1.7-3.31005,2.61a40.27149,40.27149,0,0,0-6.99024,7.66A38.48741,38.48741,0,0,0,827.34138,497.97109Z" transform="translate(-108.75634 -68.49293)" fill="#2f2e41"/><path d="M827.34138,497.97109a39.41035,39.41035,0,0,0,36.8999,26.81006,196.14623,196.14623,0,0,0,22.56982-13.39l-.8999,8.61-7.83984,75.42a4.51415,4.51415,0,0,0,4.48,4.97h15.52978a4.50547,4.50547,0,0,0,4.35987-3.36l9.15039-34.85,16.48974-62.8a19.032,19.032,0,0,0-19.71-23.83l-53.25976,3.65,3.71972-14.88-26.98-1.79A38.48741,38.48741,0,0,0,827.34138,497.97109Z" transform="translate(-108.75634 -68.49293)" fill="#2f2e41"/><path d="M838.7735,458.32082l-.35766-.043-8.29517-40.78515c-.071-.354-6.85229-35.5332,13.93677-53.92432l.36182-2.51709a4.50032,4.50032,0,0,1,5.78711-3.65771l19.58471,6.0747a4.49086,4.49086,0,0,1,3.019,5.4419l-1.90381,7.2417c2.63989,3.1001,33.7146,40.51221,22.89038,69.33545L888.9488,464.439Z" transform="translate(-108.75634 -68.49293)" fill="#6c63ff"/><path d="M920.09389,426.48986a10.52591,10.52591,0,0,0-1.32908.99037l-47.89739-12.858-3.13136-11.634-18.17538,2.43095,3.54192,21.13437a8,8,0,0,0,6.95146,6.62248l56.032,6.619a10.4971,10.4971,0,1,0,4.00785-13.30516Z" transform="translate(-108.75634 -68.49293)" fill="#ffb8b8"/><path d="M869.022,414.43646,846.48068,417.34a4.5,4.5,0,0,1-5.07405-4.54822l.42987-22.65461a12.49741,12.49741,0,0,1,24.79917-3.12052l6.14215,21.73423a4.5,4.5,0,0,1-3.75583,5.68559Z" transform="translate(-108.75634 -68.49293)" fill="#6c63ff"/><circle cx="753.92061" cy="258.80372" r="24.56103" fill="#ffb8b8"/><path d="M861.3848,329.34791l-3.075-5.59966c-5.82461,23.73215,4.46383,43.37315,4.46383,43.37315l-39.93243-18.601.38033-6.59991-3.95134,4.484-5.67747-3.12872-.74992-4.28064-4.28563,1.06158,15.64354-28.38736c15.18238-27.01314,37.25508-16.69982,37.25508-16.69982,35.11544-1.66934,30.82681,32.97543,30.82681,32.97543Z" transform="translate(-108.75634 -68.49293)" fill="#2f2e41"/><ellipse cx="556.1612" cy="472.39114" rx="12.17949" ry="47.5" transform="translate(-275.75171 306.36236) rotate(-32.66242)" fill="#3f3d56"/></svg>
                            </div>
                            <div class="">
                                <a href="#" class="flex flex-row items-center h-full">
                                    <div class="flex flex-col justify-between p-4 leading-normal w-full">
                                        <h5 class="mb-3 text-5xl font-bold tracking-tight text-white text-center">Featured Domestic Destinations</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center my-10">
                    <div v-if="length_of_dom === 0">
                        <div class="my-5">
                            <div class="">
                                <a class="flex flex-row items-center h-full">
                                    <div class="flex flex-col justify-between p-4 leading-normal w-full">
                                        <h5 class="mb-3 text-2xl font-bold tracking-tight text-blue-500 text-center">No flights available yet</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="page_loaded === false">
                            <div role="status" class="flex justify-center items-center my-5">
                                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-10 gap-4">
                                <div v-for="domestic in domestic_flights.slice().reverse()" :key="domestic">
                                    <div class="max-w-sm rounded overflow-hidden shadow-lg">
                                        <div class="aspect-w-16 aspect-h-9">
                                            <img class="object-cover h-48 w-96" :src="domestic.photo_link" alt="Sunset in the mountains">
                                        </div>
                                        <div class="px-6 py-4 bg-white h-64 overflow-hidden">
                                            <div class="font-bold text-xl mb-2">{{ domestic.destination }}</div>
                                            <p class="text-gray-700 text-base text-justify">
                                                {{ truncatedDescription(domestic.description) }}
                                            </p>
                                        </div>
                                        <div class="px-6 pt-4 pb-2 flex items-center justify-center bg-white">
                                            <button @click="bookDomestic(domestic.id)" type="button" class="text-blue-700 w-80 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Book now!</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div> -->
        <!-- End -->

        <!-- International -->
        <!-- <div class="mb-10">
            <section id="feature">
                <div class="bg-yellow-400">
                    <div class="flex items-center justify-center">
                        <div class="grid md:grid-cols-2 gap-4 mx-4 mt-5 mb-5">
                            <div class="my-5 flex items-center justify-center">
                                <InternationalSVG/>
                            </div>
                            <div class="">
                                <a href="#" class="flex flex-row items-center h-full">
                                    <div class="flex flex-col justify-between p-4 leading-normal w-full">
                                        <h5 class="mb-3 text-5xl font-bold tracking-tight text-white text-center">Featured International Destinations</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex items-center justify-center my-10">
                    <div v-if="length_of_inter === 0">
                        <div class="my-5">
                            <div class="">
                                <a class="flex flex-row items-center h-full">
                                    <div class="flex flex-col justify-between p-4 leading-normal w-full">
                                        <h5 class="mb-3 text-2xl font-bold tracking-tight text-blue-500 text-center">No flights available yet</h5>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="page_loaded === false">
                            <div role="status" class="flex justify-center items-center my-5">
                                <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                </svg>
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-10 gap-4">
                                <div v-for="international in international_flights.slice().reverse()" :key="international">
                                    <div class="max-w-sm rounded overflow-hidden shadow-lg">
                                        <div class="aspect-w-16 aspect-h-9">
                                            <img class="object-cover h-48 w-96" :src="international.photo_link" alt="Sunset in the mountains">
                                        </div>
                                        <div class="px-6 py-4 bg-white h-64 overflow-hidden">
                                            <div class="font-bold text-xl mb-2">{{ international.destination }}</div>
                                            <p class="text-gray-700 text-base text-justify">
                                                {{ truncatedDescription(international.description) }}
                                            </p>
                                        </div>
                                        <div class="px-6 pt-4 pb-2 flex items-center justify-center bg-white">
                                            <button @click="bookInternational(international.id)" type="button" class="text-blue-700 w-80 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Book now!</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div> -->
        <!-- End -->

    <!-- </div> -->
    <!-- Mission and Vision -->
    <div class="bg-blue-500 py-5">
        <section id="about" class="ms-5 me-5">
            <h1 class="text-5xl text-center font-bold mb-5 mt-5 text-white">Our mission and vision statement</h1>
            <div class="grid mb-2 border border-gray-200 rounded-lg shadow-sm md:grid-cols-2 bg-opacity-50 bg-blur-md backdrop-filter backdrop-blur-md backdrop-saturate-150">
                <figure class="flex flex-col items-center justify-center p-8 text-center rounded-t-lg md:rounded-t-none md:rounded-ss-lg md:border-e ">
                    <blockquote class="max-w-2xl mx-auto mb-4 text-gray-500 lg:mb-8">
                        <h3 class="text-lg font-semibold text-white">Mission</h3>
                        <p class="my-4 text-white">To provide affordable services that can cater all customers  from all walks of life. Helping people to travel smart and providing them quality service that ensures to satisfy their needs by our provided services.</p>
                    </blockquote>
                    <figcaption class="flex items-center justify-center ">
                        <img class="rounded-full w-9 h-9" src="../assets/logo_with_bg/2.png" alt="CEO Profile Picture">
                        <div class="space-y-0.5 font-medium rtl:text-right ms-3">
                            <div class="text-white">Joseph Louie B. Solcoretes</div>
                            <div class="text-sm text-white">Owner/CEO of AirProve</div>
                        </div>
                    </figcaption>    
                </figure>
                <figure class="flex flex-col items-center justify-center p-8 text-center md:rounded-se-lg ">
                    <blockquote class="max-w-2xl mx-auto mb-4 text-gray-500 lg:mb-8">
                        <h3 class="text-lg font-semibold text-white">Vision</h3>
                        <p class="my-4 text-white">To be one of the growing, reliable, trusted and efficient travel agencies not just in Naga City Camarines Sur but to be known nationwide.</p>
                    </blockquote>
                    <figcaption class="flex items-center justify-center ">
                        <img class="rounded-full w-9 h-9" src="../assets/logo_with_bg/1.png" alt="COO Profile Picture">
                        <div class="space-y-0.5 font-medium text-left rtl:text-right ms-3">
                            <div class="text-white">Christian James V. Morisca</div>
                            <div class="text-sm text-white">Owner/COO of AirProve</div>
                        </div>
                    </figcaption>    
                </figure>
            </div>
        </section>
        <div class="px-6 pt-4 pb-2 flex items-center justify-center">
            <button name="learnMore" @click="ourCompany" href="#Top" type="button" class="text-white w-80 hover:text-white bg-yellow-400 border border-yellow-400 hover:bg-yellow-600 font-medium rounded-full text-md px-5 py-2.5 text-center me-2 mb-2">Learn more</button>
        </div>
    </div>
    <!-- End -->

    <!-- Customer Reviews -->
    <div>
        <section class="mx-5 my-10" id="feedback">
            <h1 class="text-5xl text-center font-bold mb-5 text-slate-900">What Our Customers Are Saying</h1>
            <div v-if="length_of_reviews === 0">
                <div class="my-5">
                    <div class="mx-4">
                        <!-- <a class="flex flex-row items-center h-full">
                            <div class="flex flex-col justify-between p-4 leading-normal w-full">
                                <h5 class="mb-3 text-2xl font-bold tracking-tight text-blue-500 text-center">No reviews available. Leave one below!</h5>
                            </div>
                        </a> -->
                        <p class="text-base md:text-lg lg:text-xl text-center font-semibold text-slate-900">If you had any issues or you liked our services, please share it with us.</p>
                        <div class="text-center py-5">
                            <p class="text-sm md:text-base lg:text-lg">
                                By clicking here, you can send to us your <a href="https://forms.gle/ypm16GiHPn12paTb8" class="hover:underline text-blue-500 hover:text-blue-800">thoughts and feedback</a>.
                            </p>
                        </div>
                        <CarouselComp/>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="page_loaded === false">
                    <div role="status" class="flex justify-center items-center my-5">
                        <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <!-- <div v-else>
                    <div class="grid mb-8 border border-gray-200 rounded-lg shadow-sm md:mb-12 md:grid-cols-2 shadow-xl">
                        <div v-for="reviews in reviews_arr" :key="reviews">
                            <figure class="flex flex-col items-center justify-center p-8 text-center bg-opacity-50 bg-blur-md backdrop-filter backdrop-blur-md backdrop-saturate-150 border-b border-gray-200 rounded-t-lg md:rounded-t-none md:rounded-ss-lg md:border-e">
                                <blockquote class="max-w-2xl mx-auto mb-4 text-gray-500 lg:mb-8 dark:text-gray-400">
                                    <h3 class="text-lg font-semibold text-slate-900 ">{{ reviews.subject }}</h3>
                                    <p class="my-4 text-slate-900">
                                        {{ reviews.message }}
                                    </p>
                                </blockquote>
                                <figcaption class="flex items-center justify-center ">
                                    <div class="space-y-0.5 font-medium  text-center rtl:text-right ms-3">
                                        <div class="text-slate-900">{{ reviews.name }}</div>
                                        
                                        <div class="flex items-center mt-2.5 mb-5">
                                            <div class="flex items-center space-x-1 rtl:space-x-reverse">
                                                <svg v-for="index in 5" :key="index" class="w-4 h-4" :class="{ 'text-yellow-300': index <= reviews.rate, 'text-gray-200': index > reviews.rate }" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                    <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z"/>
                                                </svg>
                                            </div>
                                            <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 ms-3">{{ reviews.rate }}.0</span>
                                        </div>
                                    </div>
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                </div> -->
            </div>
            
            <!-- <div>
                <p class="text-5xl text-center font-bold mb-5 text-slate-900">Let us hear your thoughts!</p>
                <p class="text-xl text-center font-bold mb-5 text-slate-900">If you had any issues or you liked our services, please share it with us.</p>
                <form action="#" class="space-y-8 mx-10" @submit.prevent="feedback_submit">
                    <div>
                        <label for="name" class="block mb-2 text-sm font-base text-gray-900">Your name</label>
                        <input type="text" v-model="feedback_name" id="name" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5" placeholder="Juan Dela Cruz" required>
                    </div>
                    <div>
                        <label for="email" class="block mb-2 text-sm font-base text-gray-900">Your email</label>
                        <input type="email" v-model="feedback_email" id="email" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5" placeholder="name@gmail.com" required>
                    </div>
                    <div>
                        <label for="subject" class="block mb-2 text-sm font-base text-gray-900">Subject</label>
                        <input type="text" v-model="feedback_subject" id="subject" class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500" placeholder="Let us know how we can help you" required>
                    </div>
                    
                    <div class="relative mb-6">
                        <label for="labels-range-input" class="text-sm font-base text-gray-900">Overall Satisfaction</label>
                        <input id="labels-range-input" v-model="statisfaction" type="range" min="1" max="5" class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer">
                        <span class="text-sm text-red-700 absolute left-0 -bottom-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-emoji-angry-fill" viewBox="0 0 16 16">
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M4.053 4.276a.5.5 0 0 1 .67-.223l2 1a.5.5 0 0 1 .166.76c.071.206.111.44.111.687C7 7.328 6.552 8 6 8s-1-.672-1-1.5c0-.408.109-.778.285-1.049l-1.009-.504a.5.5 0 0 1-.223-.67zm.232 8.157a.5.5 0 0 1-.183-.683A4.5 4.5 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 1 1-.866.5A3.5 3.5 0 0 0 8 10.5a3.5 3.5 0 0 0-3.032 1.75.5.5 0 0 1-.683.183M10 8c-.552 0-1-.672-1-1.5 0-.247.04-.48.11-.686a.502.502 0 0 1 .166-.761l2-1a.5.5 0 1 1 .448.894l-1.009.504c.176.27.285.64.285 1.049 0 .828-.448 1.5-1 1.5"/>
                            </svg>
                        </span>
                        <span class="text-sm text-orange-600 absolute left-1/4 -translate-x-1/2 -bottom-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-emoji-frown-fill" viewBox="0 0 16 16">
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-2.715 5.933a.5.5 0 0 1-.183-.683A4.5 4.5 0 0 1 8 9.5a4.5 4.5 0 0 1 3.898 2.25.5.5 0 0 1-.866.5A3.5 3.5 0 0 0 8 10.5a3.5 3.5 0 0 0-3.032 1.75.5.5 0 0 1-.683.183M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8"/>
                            </svg>
                        </span>
                        <span class="text-sm text-amber-600 absolute left-1/2 -translate-x-1/2 -bottom-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-emoji-neutral-fill" viewBox="0 0 16 16">
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5m-3 4a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8"/>
                            </svg>
                        </span>
                        <span class="text-sm text-yellow-400 absolute left-3/4 -translate-x-1/2 -bottom-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-emoji-smile-fill" viewBox="0 0 16 16">
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5M4.285 9.567a.5.5 0 0 1 .683.183A3.5 3.5 0 0 0 8 11.5a3.5 3.5 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683M10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8"/>
                            </svg>
                        </span>
                        <span class="text-sm text-lime-500 absolute right-0 -bottom-6">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-emoji-grin-fill" viewBox="0 0 16 16">
                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16M6.488 7c-.23-.598-.661-1-1.155-1-.493 0-.924.402-1.155 1A2.8 2.8 0 0 1 4 6c0-1.105.597-2 1.333-2 .737 0 1.334.895 1.334 2 0 .364-.065.706-.179 1m5.334 0c-.23-.598-.662-1-1.155-1-.494 0-.925.402-1.155 1a2.8 2.8 0 0 1-.179-1c0-1.105.597-2 1.334-2C11.403 4 12 4.895 12 6c0 .364-.065.706-.178 1M2.696 8.756a.48.48 0 0 1 .382-.118C4.348 8.786 6.448 9 8 9c1.553 0 3.653-.214 4.922-.362a.48.48 0 0 1 .383.118.3.3 0 0 1 .096.29c-.09.47-.242.921-.445 1.342-.263.035-.576.075-.929.115A37 37 0 0 1 8 10.75c-1.475 0-2.934-.123-4.027-.247-.353-.04-.666-.08-.93-.115A5.5 5.5 0 0 1 2.6 9.045a.3.3 0 0 1 .097-.29ZM8 13.5a5.49 5.49 0 0 1-4.256-2.017l.116.014c1.115.126 2.615.253 4.14.253s3.025-.127 4.14-.253l.117-.014A5.49 5.49 0 0 1 8 13.5"/>
                            </svg>
                        </span>
                    </div>
                    
                    <div class="sm:col-span-2">
                        <label for="message" class="block mb-2 text-sm font-base text-gray-900 dark:text-gray-400">Your message</label>
                        <textarea id="message" v-model="feedback_message" rows="6" class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500" placeholder="Leave a comment..." required></textarea>
                    </div>
                    <button type="submit" class="py-3 px-5 text-sm font-base text-center text-white rounded-lg bg-blue-500 sm:w-fit hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Send feedback</button>
                </form>
            </div> -->
        </section>
        <div id="ad_id">
            <amp-ad width="100vw" height="320"
                type="adsense"
                data-ad-client="ca-pub-5580517504444924"
                data-ad-slot="8950603964"
                data-auto-format="rspv"
                data-full-width="">
                <div overflow=""></div>
            </amp-ad>
        </div>
    </div>
    <!-- <div class="d-flex items-center">
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScLf6bC5WRTsJng8-yjhUzFHNLKNP2ajfmYL-vvps6eeVurkA/viewform?embedded=true" width="640" height="2550" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </div> -->
    <!-- End -->

    <div class="bg-yellow-400">
        <div class="flex items-center justify-center">
            <div class="grid md:grid-cols-2 gap-4 mx-4 mt-5 mb-5">
                <div class="my-5 flex items-center justify-center">
                    <DiscoverSVG/>
                </div>
                <div class="">
                    <div class="flex flex-row items-center h-full">
                        <div class="flex flex-col justify-between p-4 leading-normal w-full">
                            <h5 class="mb-3 text-5xl font-bold tracking-tight text-white ">Explore You!</h5>
                            <p class="text-white text-base text-justify">
                                Life is full of mystery, and to fulfill the mystery of life- exploring is what's 
                                best to do. Our tagline is all about our clients, “exploring you” can make a 
                                huge difference in how you perceive, deal and live your life. It can give you 
                                freedom, peace and new and exciting experiences that will help you build up who 
                                you truly are and what you want to become. Traveling can make up a big space of 
                                change in life. Experiencing new cultures, traveling to new places and meeting new 
                                people are aspects of exploring that can definitely add up to who you really are. 
                                Feeling alive and freedom is what traveling does to people and that's our goal as 
                                a company ( airprove ) is providing you affordable and quality travel experience.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <PageFooter/>

    <div v-if="modal === true">
        <PopUpModal>
            <!-- Modal content -->
            <div class="relative bg-white">
                <!-- Modal header -->
                <div class="flex items-center justify-between p-4 md:p-5">
                    <h3 class="text-lg font-semibold text-gray-900 ">
                        Book Your Trip (Destination: {{ trip_name_holder }})
                    </h3>
                    <button name="closeModal" @click="toggleModal" type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center" data-modal-toggle="crud-modal">
                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>
                <!-- Modal body -->
                <form class="p-4 md:p-5" @submit.prevent="bookTrip">
                    <div class="grid gap-4 mb-4 grid-cols-2">                  
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">Trip Type</label>
                            <div class="flex">
                                <div class="flex items-center me-4">
                                    <input type="radio" value="round-trip" v-model="trip_type" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                    <label class="ms-2 text-sm font-medium text-gray-900">Round Trip</label>
                                </div>
                                <div class="flex items-center me-4">
                                    <input type="radio" value="one-way" v-model="trip_type" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                    <label class="ms-2 text-sm font-medium text-gray-900">One Way Trip</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">No. of Passengers</label>
                            <input type="number" v-model="no_of_passengers" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. 4" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">Departure</label>
                            <input type="date" v-model="departure" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. John T. Smith, James V. Doe" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">Return</label>
                            <input type="date" v-model="return_from_trip" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. johnsmith@example.com" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">Name/s</label>
                            <input type="text" v-model="name_of_people" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. John T. Smith, James V. Doe" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">E-mail</label>
                            <input type="email" v-model="email_add" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. johnsmith@example.com" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label for="price" class="block mb-2 text-sm font-medium text-gray-900 ">Phone Number</label>
                            <input type="tel"  v-model="phone_numbers" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="09123456789" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">Address</label>
                            <input type="text" v-model="address" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. Blk 1 lot 1 Sesame St. Brgy Pacol" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label for="price" class="block mb-2 text-sm font-medium text-gray-900 ">City</label>
                            <input type="text"  v-model="city" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. Naga City" required="">
                        </div>
                        <div class="col-span-1 sm:col-span-1">
                            <label  class="block mb-2 text-sm font-medium text-gray-900 ">State/Province</label>
                            <input type="text" v-model="state_or_province" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5" placeholder="e.g. Camarines Sur" required="">
                        </div>
                    </div>
                    <button name="submitBtn" :disabled="!acceptedTC" type="submit"
                        :class="[
                            acceptedTC ? 'bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300' : 'bg-gray-400',
                            'text-white inline-flex items-center font-medium rounded-lg text-sm px-5 py-2.5 text-center'
                        ]" 
                    >
                        <svg class="me-1 -ms-1 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clip-rule="evenodd"></path></svg>
                        Book
                    </button>
                    &nbsp;
                    <div class="items-center inline-flex">
                        <input id="default-checkbox" type="checkbox" value="" v-model="acceptedTC" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                        <label for="default-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Book? Accept <router-link class="hover:text-blue-500 text-blue-800 underline" :to="{name: 'terms-page'}">Terms & Conditions!</router-link></label>
                    </div>
                </form>
            </div>
        </PopUpModal>
    </div>
</template>

<script>
import TailwindButton from '@/components/TailwindButton.vue'
import FlightSearch from '@/components/FlightSearch.vue'
import NavbarComp from '@/components/NavbarComp.vue'
import PageFooter from '@/components/PageFooter.vue'
import DiscoverSVG from '@/components/DiscoverSVG.vue'
// import InternationalSVG from '@/components/InternationalSVG.vue'
import PopUpModal from '@/components/PopUpModal.vue'
// import festivitiesSVG from '@/components/festivitiesSVG.vue'
import BlogComp from '@/components/BlogComp.vue'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import CarouselComp from '@/components/CarouselComp.vue'
import BrandnewComp from '@/components/BrandnewComp.vue'
import { useHead } from '@vueuse/head'

import Parse from 'parse';
Parse.serverURL = 'https://parseapi.back4app.com';
Parse.initialize('A9iU0asj7lBx8THtL3OuHVdKAebIUED9GJKzrpWn', 'AQmS27wK0tZHTPFga30Afa0eMTqnBmzf7zk9yX4F');

export default {
    name: 'LandingPage',
    data(){
        return{
            modal: false,
            id_holder: '',
            no_of_passengers: '',
            departure: '',
            return_from_trip: '',
            name_of_people: '',
            email_add: '',
            phone_numbers: '',
            address: '',
            city: '',
            state_or_province: '',
            trip_type: '',

            trip_name_holder: '',
            domestic_flights: [],
            international_flights: [],
            holiday_flights: [],

            length_of_dom: '',
            length_of_inter: '',
            length_of_holi: '',

            page_loaded: false,

            feedback_name: '',
            feedback_email: '',
            feedback_subject: '',
            feedback_message: '',

            customer_bookings: [],

            statisfaction: '',
            reviews_arr: [],
            review_approval: false,
            length_of_reviews: '',

            comp_click: false,
            buttonClicked: false,

            receivedMessage: '',
            acceptedTC: false,

            currentIndex: 0,
            img_items: [
                { img: require('../assets/mariners_pic.jpg') },
                { img: require('../assets/ncf_banner_pic.jpg') },
                { img: require('../assets/mariners_pic.jpg') },
                { img: require('../assets/ncf_banner_pic.jpg') },
                { img: require('../assets/mariners_pic.jpg') },
                { img: require('../assets/ncf_banner_pic.jpg') },
            ],
        }
    },
    components: { TailwindButton, FlightSearch, NavbarComp, PageFooter, DiscoverSVG, PopUpModal, BlogComp, CarouselComp, BrandnewComp }, //festivitiesSVG InternationalSVG
    beforeUnmount(){
        this.stopAutoScroll();
    },

    methods: {
        nextSlide() {
            this.currentIndex = (this.currentIndex + 1) % this.img_items.length;
        },

        prevSlide() {
            this.currentIndex = (this.currentIndex - 1 + this.img_items.length) % this.img_items.length;
        },

        goToSlide(index) {
            this.currentIndex = index;
        },

        autoScroll() {
            this.interval = setInterval(this.nextSlide, 3000); // Change slide every 3 seconds
        },

        stopAutoScroll() {
            clearInterval(this.interval);
        },
        receiveData(data){
            this.receivedMessage = data.message;
            if(this.receivedMessage === true ){
                this.comp_click = false;
                this.buttonClicked = false;
            }
        },

        change_form() {
            this.comp_click = true;
            this.buttonClicked = true; // Hide the button after it's clicked
        },

        outwardBoundPage(){
            this.$router.push({name: 'outward'});
        },
        cultureCurious(){
            this.$router.push({name: 'culture'});
        },
        relaxPage(){
            this.$router.push({name: 'relax'});
        },
        ourCompany(){
            this.$router.push({name: 'team'});
        },

        truncatedDescription(description) {
            const maxCharacters = 340;
            if (description && description.length > maxCharacters) {
                return description.substring(0, maxCharacters) + '...';
            } else {
                return description;
            }
        },

        feedback_submit(){
            if(this.customer_bookings.includes(this.feedback_email)){
                const Reviews = Parse.Object.extend("customer_reviews");
                const customer_review = new Reviews();
                customer_review.set("customer_name", this.feedback_name);
                customer_review.set("customer_email", this.feedback_email);
                customer_review.set("customer_subject", this.feedback_subject);
                customer_review.set("customer_message", this.feedback_message);
                customer_review.set("customer_satisfaction", this.statisfaction);
                customer_review.set("admin_approval", this.review_approval);

                customer_review.save().then((customer_review) => {
                    customer_review;
                    this.PopUpFeedback();
                }, (error) => {
                    alert('Error:' + error.message);
                });
                this.feedback_name = '';
                this.feedback_email = '';
                this.feedback_message = '';
                this.feedback_subject = '';
                this.statisfaction = '';
            } else {
                this.PopUpError();
                this.feedback_name = '';
                this.feedback_email = '';
                this.feedback_message = '';
                this.feedback_subject = '';
                this.satisfaction = '';
            }
        },

        PopUpError(){
            Swal.fire({
                icon: 'error', title: "Email not found", 
                text: "Book a trip today and send us a review!",
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
            });
        },


        PopUpFeedback(){
            Swal.fire({
                icon: 'success', 
                title: "Thank you for your feedback!", 
                text: "We will make sure to provide you a top-notch service!",
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
            });
        },

        bookTrip(){
            const Booked_trip = Parse.Object.extend("bookings");
            const booked_trip = new Booked_trip();
            booked_trip.set("trip_type", this.trip_type);
            booked_trip.set("no_of_passengers", this.no_of_passengers);
            booked_trip.set("departure", this.departure);
            booked_trip.set("return_", this.return_from_trip);
            booked_trip.set("name", this.name_of_people);
            booked_trip.set("email", this.email_add);
            booked_trip.set("phone_number", this.phone_numbers);
            booked_trip.set("address", this.address);
            booked_trip.set("city", this.city);
            booked_trip.set("state_or_province", this.state_or_province);
            booked_trip.set("destination", this.trip_name_holder);
            booked_trip.set("status", "pending");

            booked_trip.save().then((booked_trip) => {
                booked_trip;
                this.popUp();
                // if(!booked_trip.id){
                //     this.popUp();
                // }
            }, (error) => {
                alert('Error:' + error.message);
            });

            this.modal = false;
            this.id_holder = "";
            this.no_of_passengers = "";
            this.departure = "";
            this.return_from_trip = "";
            this.name_of_people = "";
            this.email_add = "";
            this.phone_numbers = "";
            this.address = "";
            this.city = "";
            this.state_or_province = "";
            this.trip_type = "";
            this.acceptedTC = false;
        },

        popUp(){
            Swal.fire({
                icon: 'success', title: "Booked!", text: "Wait for our admin to contact you thru e-mail and SMS",
                showCancelButton: false,
                showConfirmButton: false,
                showCloseButton: true,
                // timer: 3000,
                // timerProgressBar: true,
            });
        },

        bookDomestic(id){
            this.id_holder = id;
            this.modal = !this.modal;
            for(let j = 0; j < this.domestic_flights.length; j++){
                if(this.id_holder === this.domestic_flights[j].id){
                    this.trip_name_holder = this.domestic_flights[j].destination;
                }
            }
        },

        bookInternational(id){
            this.id_holder = id;
            this.modal = !this.modal;
            for(let j = 0; j < this.international_flights.length; j++){
                if(this.id_holder === this.international_flights[j].id){
                    this.trip_name_holder = this.international_flights[j].destination;
                }
            }
        },

        bookHoli(id){
            this.id_holder = id;
            this.modal = !this.modal;
            for(let j = 0; j < this.holiday_flights.length; j++){
                if(this.id_holder === this.holiday_flights[j].id){
                    this.trip_name_holder = this.holiday_flights[j].destination;
                }
            }
        },

        toggleModal(){
            this.modal = false;
            this.id_holder = '';
        },
    },

    mounted: async function(){
        const { meta } = this.$route;

        useHead({
            title: meta.title,
            meta: [
                { name: 'description', content: meta.description },
                { property: 'og:title', content: meta.ogTitle },
                { property: 'og:description', content: meta.ogDescription },
                { property: 'og:image', content: meta.ogImage },
                { property: 'og:url', content: meta.ogUrl },
            ],
        });
        
        this.autoScroll();
        const International = Parse.Object.extend("international");
        const international = new Parse.Query(International);
        const query_inter = await international.find();

        for(let i = 0; i < query_inter.length; i++){
            this.international_flights.push({
                id: query_inter[i].id,
                destination: query_inter[i].get("destination"),
                description: query_inter[i].get("description"),
                photo_link: query_inter[i].get("photo_link"),
                price: query_inter[i].get("price"),
                promo_code: query_inter[i].get("promo_code"),
            })
            this.page_loaded = true;
        }

        this.length_of_inter = this.international_flights.length;

        const Domestic = Parse.Object.extend("domestic");
        const domestic = new Parse.Query(Domestic);
        const query_dom = await domestic.find();

        for(let j = 0; j < query_dom.length; j++){
            this.domestic_flights.push({
                id: query_dom[j].id,
                destination: query_dom[j].get("destination"),
                description: query_dom[j].get("description"),
                photo_link: query_dom[j].get("photo_link"),
                price: query_dom[j].get("price"),
                promo_code: query_dom[j].get("promo_code"),
            })
            this.page_loaded = true;
        }

        this.length_of_dom = this.domestic_flights.length;

        const Holiday = Parse.Object.extend("holiday");
        const holiday = new Parse.Query(Holiday);
        const query_holi = await holiday.find();

        for(let j = 0; j < query_holi.length; j++){
            this.holiday_flights.push({
                id: query_holi[j].id,
                destination: query_holi[j].get("destination"),
                description: query_holi[j].get("description"),
                photo_link: query_holi[j].get("photo_link"),
                price: query_holi[j].get("price"),
                promo_code: query_holi[j].get("promo_code"),
            })
            this.page_loaded = true;
        }

        this.length_of_holi = this.holiday_flights.length;

        // const Bookings = Parse.Object.extend("bookings");
        // const bookings = new Parse.Query(Bookings);
        // const query_bookings = await bookings.find();

        // for(let k = 0; k < query_bookings.length; k++){
        //     this.customer_bookings.push(query_bookings[k].get("email"))
        // }

        const Reviews = Parse.Object.extend("customer_reviews");
        const customer_reviews = new Parse.Query(Reviews);
        const c_query = await customer_reviews.find();
        
        for(let j = 0; j < c_query.length; j++){
            if(c_query[j].get("admin_approval") === true){
                this.reviews_arr.push({
                    id: c_query[j].id,
                    name: c_query[j].get("customer_name"),
                    email: c_query[j].get("customer_email"),
                    subject: c_query[j].get("customer_subject"),
                    message: c_query[j].get("customer_message"),
                    rate: c_query[j].get("customer_satisfaction"),
                })
            }
            this.page_loaded = true;
        }
        this.length_of_reviews = this.reviews_arr.length;
    }
}
</script>

<style>
.fade-content {
  transition: opacity 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.video-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 98.vw; /* Full viewport width */
    height: 100vh; /* Full viewport height */
    overflow: hidden; /* Hide overflow */
    z-index: -1; /* Place behind other content */
}

.video-background video {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%; /* Cover the width of the container */
    height: 100%; /* Cover the height of the container */
    object-fit: cover; /* Cover the container while maintaining aspect ratio */
    transform: translate(-50%, -50%); /* Center the video */
}

#learn-more{
    z-index: -10;
}
</style>